
// ABOUTME: Custom hook for fetching detailed role information by ID
// ABOUTME: Provides role data with statistics for role detail views

import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from './useAuth';
import type { JobRoleWithStats } from './useJobRoles';

export function useRoleDetail(roleId: string) {
  const { user } = useAuth();

  const { data: role, isLoading, error } = useQuery({
    queryKey: ['role-detail', roleId],
    queryFn: async () => {
      if (!roleId) return null;

      const { data, error } = await supabase
        .from('job_roles')
        .select(`
          *,
          referrals:referrals(
            id,
            status
          )
        `)
        .eq('id', roleId)
        .single();

      if (error) throw error;

      // Transform the data to include calculated statistics
      const referrals = data.referrals || [];
      const total_referrals = referrals.length;
      const active_referrals = referrals.filter(ref => 
        ['submitted', 'under_review', 'interview_scheduled', 'interviewed'].includes(ref.status || '')
      ).length;
      const hired_count = referrals.filter(ref => ref.status === 'hired').length;

      const roleWithStats: JobRoleWithStats = {
        ...data,
        total_referrals,
        active_referrals,
        hired_count,
        required_tools: (data as any).Required_tools || (data as any).required_tools || null,
        essential_skills: (data as any).Essential_Skills || null
      };

      return roleWithStats;
    },
    enabled: !!roleId && !!user?.id,
  });

  return {
    role,
    isLoading,
    error,
  };
}
